export enum EventType {
  Destroy,
  Invoke,
  Discard,
  Attack,
  PassTurn,
}
